import F from 'offline/filter/constants'
// Port of api/fuel/app/classes/filter/package/games/collection/prepare/inventory.php
export default {
	run: function(local, global) {
		if (global.ownerType !== F.OWNER_USER) return local
		local.collection = local.collection || {}
		if (global.can && global.can['view.inventory.location']) {
			var coll = global.collections ? global.collections[local.id] : null
			local.collection.location = coll ? (coll.collection_private_location || '') : ''
		} else {
			local.collection.location = false
		}
		return local
	}
}
